module.exports = __webpack_public_path__ + "img/empty.56f5468d.png";